import type { EtatDeLaMaintenance } from '@upfac/api-contract'
import { api } from './client'

// RG-A5 à RG-A7 — la forme vient du contrat GÉNÉRÉ depuis le backend. La
// redéclarer ici créerait deux vérités : le jour où l'API change, c'est la
// copie qui ment, et TypeScript ne le voit pas.
export type { EtatDeLaMaintenance }

/**
 * L'état de la maintenance — [DECISIONS §196], RG-9.13.
 *
 * **Sans session, et c'est le point.** La route est publique : un visiteur de
 * la vitrine doit apprendre que le site est en maintenance plutôt que de
 * conclure qu'il est mort. Elle est aussi la seule route qui réponde encore
 * sous `php artisan down`.
 */
export async function etatDeLaMaintenance(): Promise<EtatDeLaMaintenance> {
  const res = await api<{ data: EtatDeLaMaintenance }>('/maintenance')

  return res.data
}
